<div class="controls-container">
    <div class="controls-header">Busy Indicators</div>

    <div class="controls-sub-header">Busy Indicator Circular</div>

    <pm-busy-indicator-circular></pm-busy-indicator-circular>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->
    
    <div class="controls-sub-header">Busy Indicator Control</div>
    
    <pm-busy-indicator-control></pm-busy-indicator-control>
    
    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->

    <div class="controls-sub-header">Busy Indicator Linear</div>
    
    <pm-busy-indicator-linear></pm-busy-indicator-linear>
    
    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->

    <div class="controls-sub-header">Busy Indicator Overlay</div>

    <div style="height: 300px; width: 400px; position:relative;">
        <div style="background: rgb(238, 238, 238); border-radius: 5px; width: 100%; height: 100%; display: flex; align-items: center;"> Hello World</div>
        <pm-busy-indicator-overlay></pm-busy-indicator-overlay>
    </div>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->

    <div class="controls-sub-header">Busy Indicator Overlay Circular</div>

    <div style="height: 300px; width: 400px; position:relative;">
        <div style="background: rgb(238, 238, 238); border-radius: 5px; width: 100%; height: 100%; display: flex; align-items: center;">
        Hello World</div>
        <pm-busy-indicator-overlay-circular></pm-busy-indicator-overlay-circular>
    </div>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/busy-indicators/busy-indicators.html